import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-finance-bill-statement",
  "use": "icon-finance-bill-statement-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-finance-bill-statement\"><path d=\"M205.6,87.44H14.4L110,15Zm-164.42-9H178.82L110,26.28Z\" /><rect x=\"44.73\" y=\"101.32\" width=\"9\" height=\"48.51\" /><rect x=\"166.27\" y=\"101.32\" width=\"9\" height=\"48.51\" /><rect x=\"105.5\" y=\"101.32\" width=\"9\" height=\"48.51\" /><path d=\"M192.12,203.86H27.88V164.22H192.12Zm-155.24-9H183.12V173.22H36.88Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol